import React from 'react';
import PropTypes from 'prop-types';
import { VerticalReviewTable } from 'web-ui-components/lib/layout/tables';
import { Grid } from 'web-ui-components/lib/layout/grids';

const PaymentInfoTable = ({ paymentDetails }) => {
	const paymentData = Object.keys(paymentDetails).map((label) => ({
		headerText: label,
		cellText: paymentDetails[label],
	}));

	return (
		<Grid.TwoThirds>
			<VerticalReviewTable data={paymentData} />
		</Grid.TwoThirds>
	);
};

PaymentInfoTable.propTypes = {
	paymentDetails: PropTypes.shape({}).isRequired,
};

export default PaymentInfoTable;
